import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col, ButtonGroup } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import CustomDropdown from "../../../../CustomDropdown/CustomDropdown";

import { CivilStatus, Gender, PersonStatus, CurrencyType, RelatedFrom } from "../../types";
import { FormField, SelectFormField, CustomFormInput, CheckFormField } from "../../../../../utils/FormFields";
import PhysicalPersonLegalAddress from "../LegalAddress";
import PhysicalPersonFiscalResidence from "../FiscalResidence";
import PhysicalPersonLegalInfo from "./LegalInfo";
import Autosuggest from "../../../../AutosuggestCompliance";
import CircularProggress from "../../../../CircularProgress/CircularProgress";
import { parseDate, toDateTime } from "../../../../../utils/dateUtils";
import Label from "reactstrap/lib/Label";
import { PersonMode } from "../../../../../utils/Helper";

function PhysicalPersonProfile({
  person,
  onChange,
  activitySectors,
  legalAddress,
  onChangeAddress,
  personLinks,
  professions,
  publicPositions,
  companyLinks,
  documentTypes,
  patrimonies,
  autosuggests,
  onChangeAutosuggest,
  disabled,
  errors,
  services,
  onboarding,
  mode,
  manual,
  viewDigitalRelatedFrom,
}) {
  const [country, setCountry] = useState({
    id: person.PhysicalPersonCountryOfBirthId,
  });
  const [birthStates, setBirthStates] = useState(undefined);
  const [error, setError] = useState(onboarding ? "Check Document First" : "");
  const [color, setColor] = useState("btn btn-ladda btn-primary");
  const [checking, setChecking] = useState(false);

  const onChangeDocumentCountry = (name) => onChangeAutosuggest("SpouseDocumentCountryOfIssue", name);
  const onChangeCountry = (name) => onChangeAutosuggest("PhysicalPersonCountryOfBirth", name);

  const fetchCountrySuggestion = (name) =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestCoutries({ text: name }, (response) => {
        if (response && response.countries) {
          const suggestions = [];
          response.countries.map((c) => {
            suggestions.push({
              id: c.Id,
              name: c.Name,
            });
            return {};
          });
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });

  const handleChangeDocumentCountry = (id, value) => {
    onChange("SpouseDocumentCountryOfIssueId", id, value);
    onChangeDocumentCountry(value);
  };
  const handleChangeCountry = (id, value) => {
    onChange("PhysicalPersonCountryOfBirthId", id, value);
    setCountry({
      id,
    });
    onChangeCountry(value);
  };

  useEffect(() => {
    setCountry({ id: person.PhysicalPersonCountryOfBirthId });
  }, [person]);

  useEffect(() => {
    const birthCountryId = country.id;
    setBirthStates(undefined);
    services.fetchCountryStates({ id: birthCountryId }, (response) => {
      if (response && response.states) {
        setBirthStates(response.states);
      } else {
        setBirthStates([]);
      }
    });
  }, [country.id]);

  const checkDocument = () => {
    if (person.PhysicalPersonMainDocumentNumber == "") {
      setColor("btn btn-ladda btn-primary");
      setError("Please, add a document number");
    } else {
      setChecking(true);
      services.fetchCheckDocument(
        {
          onboardingid: person.PersonId,
          type: person.PhysicalPersonMainDocumentTypeId,
          number: person.PhysicalPersonMainDocumentNumber,
          person: "Physical",
        },
        (response) => {
          if (response && response.result.Code === 200) {
            setColor("btn btn-ladda btn-primary");
            setError(undefined);
            setChecking(false);
            alert(response.result.Description);
          } else {
            setError("This document already exists!");
            setColor("btn btn-ladda btn-danger btn-sm");
            setChecking(false);
            alert(response.result.Description);
          }
        }
      );
    }
  };

  const onChangeDoc = (id, value, text) => {
    onChange(id, value, text);
    setError("Check Document First");
  };

  const onChangeDocNumber = (id, value) => {
    onChange(id, value);
    setError("Check Document First");
  };

  const civilStatusArray = [];
  Object.keys(CivilStatus).map((key) => {
    civilStatusArray.push({
      id: key,
      name: CivilStatus[key],
    });
    return {};
  });

  const cities = [];
  if (birthStates) {
    birthStates.map((s) => s.City.map((c) => cities.push(c)));
  }
  const personCivilStatus = person.PhysicalPersonCivilStatus;

  return (
    <div>
      {(onboarding || mode === PersonMode.New) && (
        <Row>
          <Col>
            {(onboarding || mode === PersonMode.New) && documentTypes && (
              <SelectFormField
                label="Document Type"
                value={person.PhysicalPersonMainDocumentTypeId}
                onChange={onChangeDoc}
                name="PhysicalPersonMainDocumentTypeId"
                selectItems={documentTypes}
                getSelectItemId={(doc) => doc.DocumentTypeId}
                getSelectItemName={(doc) => doc.DocumentTypeName}
                color={color}
              />
            )}
          </Col>
          <Col>
            {(onboarding || mode === PersonMode.New) && (
              <FormField
                label="Document Number"
                value={person.PhysicalPersonMainDocumentNumber}
                name="PhysicalPersonMainDocumentNumber"
                onChange={onChangeDocNumber}
                error={
                  error || errors.PhysicalPersonMainDocumentNumber
                    ? error
                      ? error
                      : errors.PhysicalPersonMainDocumentNumber
                    : undefined
                }
                color={color}
              />
            )}
          </Col>
          <Col>
            <Label>Check if the person already exist</Label>
            <div></div>
            <LaddaButton
              className={color}
              loading={checking}
              onClick={checkDocument}
              data-style={EXPAND_RIGHT}
              color={color}
            >
              <i className="fa fa-check-square" aria-hidden="true"></i>
            </LaddaButton>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <FormField
            label="First Name: "
            value={person.PhysicalPersonFirstName}
            name="PhysicalPersonFirstName"
            onChange={onChange}
            disabled={disabled || error || !manual}
            error={errors.PhysicalPersonFirstName}
          />
        </Col>
        <Col>
          <FormField
            label="Second Name: "
            value={person.PhysicalPersonSecondName}
            name="PhysicalPersonSecondName"
            onChange={onChange}
            disabled={disabled || error || !manual}
            error={errors.PhysicalPersonSecondName}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormField
            label="First Last Name: "
            value={person.PhysicalPersonFirstLastName}
            name="PhysicalPersonFirstLastName"
            onChange={onChange}
            disabled={disabled || error || !manual}
            error={errors.PhysicalPersonFirstLastName}
          />
        </Col>
        <Col>
          <FormField
            label="Second Last Name: "
            value={person.PhysicalPersonSecondLastName}
            name="PhysicalPersonSecondLastName"
            onChange={onChange}
            disabled={disabled || error || !manual}
            error={errors.PhysicalPersonSecondLastName}
          />
        </Col>
      </Row>

      <SelectFormField
        label="Status: "
        value={person.PersonStatus}
        name="PersonStatus"
        selectItems={Object.keys(PersonStatus)}
        getSelectItemId={(i) => i}
        getSelectItemName={(i) => PersonStatus[i]}
        error={errors.PersonStatus}
        onChange={onChange}
        disabled={disabled || error || onboarding || mode === PersonMode.New}
      />

      <FormField
        label="Email: "
        type="email"
        value={person.PhysicalPersonEmail}
        name="PhysicalPersonEmail"
        onChange={onChange}
        disabled={disabled || error}
        error={
          errors.PhysicalPersonEmail && !person.PersonIsMinimal ? errors.PhysicalPersonEmail : undefined
        }
      />

      {person.PersonStatus === "PassedAway" && (
        <FormField
          label="Passed Away Date: "
          type="date"
          value={
            person.PersonPassedAwayDate !== "0000-00-00"
              ? toDateTime(person.PersonPassedAwayDate)
              : new Date()
          }
          name="PersonPassedAwayDate"
          onChange={onChange}
          disabled={disabled || error}
          error={errors.PersonPassedAwayDate}
        />
      )}
      {person.PersonActivationDate && mode !== PersonMode.New && (
        <FormField
          label="Activation Date: "
          type="date"
          value={
            toDateTime(person.PersonActivationDate) == "Invalid Date"
              ? new Date()
              : toDateTime(person.PersonActivationDate)
          }
          name="PersonActivationDate"
          onChange={onChange}
          disabled={true}
          error={errors.PersonActivationDate}
        />
      )}
      {!person.PersonIsMinimal && (
        <div>
          <FormField
            label="Type: "
            disabled
            value={person.PersonType}
            name="PersonType"
            onChange={onChange}
          />
          <SelectFormField
            label="Gender: "
            value={person.PhysicalPersonGender}
            name="PhysicalPersonGender"
            selectItems={Object.keys(Gender)}
            getSelectItemId={(i) => i}
            getSelectItemName={(i) => Gender[i]}
            error={errors.PhysicalPersonGender}
            onChange={onChange}
            disabled={disabled || error || !manual}
          />

          <CheckFormField
            label="Obligated Entity? : "
            error={errors.PersonObligatedEntity}
            onChange={onChange}
            value={person.PersonObligatedEntity}
            initialValue={person.PersonObligatedEntity}
            name="PersonObligatedEntity"
            disabled={disabled || error || !manual}
          />
        </div>
      )}

      {!person.PersonIsMinimal && (
        <div>
          <Row>
            <Col>
              <FormField
                label="Date of Birth: "
                type="date"
                value={
                  parseDate(person.PhysicalPersonDateOfBirth) == "Invalid Date"
                    ? new Date()
                    : parseDate(person.PhysicalPersonDateOfBirth)
                }
                name="PhysicalPersonDateOfBirth"
                onChange={onChange}
                disabled={disabled || error || !manual}
                error={errors.PhysicalPersonDateOfBirth}
              />
            </Col>
            <Col>
              <CustomFormInput
                label="Country of Birth: "
                error={errors.PhysicalPersonCountryOfBirthId && !person.PersonIsMinimal}
              >
                <Autosuggest
                  value={autosuggests.PhysicalPersonCountryOfBirth}
                  name="PhysicalPersonCountryOfBirth"
                  onChange={onChangeCountry}
                  fecthSuggestions={fetchCountrySuggestion}
                  onSelect={handleChangeCountry}
                  disabled={disabled || error}
                />
              </CustomFormInput>
            </Col>
            <Col>
              {birthStates && !person.PersonIsMinimal && (
                <CustomDropdown
                value={person.PhysicalPersonCityOfBirthId}
                label="City of Birth: "
                name="PhysicalPersonCityOfBirthId"
                onChange={onChange}
                items={cities}
                getSelectedId={(city) => city.CityId}
                getSelectedName={(city) => city.CityName}
                getFilterCondition={(city) => city.CityName}
                disabled={disabled || error}
                error={errors.PhysicalPersonCityOfBirthId}
              />
              )}
            </Col>
          </Row>
        </div>
      )}
      <Row>
        <Col>
          <FormField
            label="Nationality: "
            value={person.PhysicalPersonNationality}
            name="PhysicalPersonNationality"
            onChange={onChange}
            disabled={disabled || error || !manual}
            error={errors.PhysicalPersonNationality}
          />
        </Col>
      </Row>

      {!person.PersonIsMinimal && (
        <div>
          <SelectFormField
            label="Civil Status: "
            value={personCivilStatus}
            name="PhysicalPersonCivilStatus"
            onChange={onChange}
            selectItems={civilStatusArray}
            getSelectItemId={(status) => status.id}
            getSelectItemName={(status) => status.name}
            disabled={disabled || error || !manual}
            error={errors.PhysicalPersonCivilStatus}
          />
          <Row>
            <Col>
              <FormField
                label="Related Person First Name: "
                value={person.SpouseFirstName}
                name="SpouseFirstName"
                onChange={onChange}
                disabled={disabled || error || !manual}
                error={errors.SpouseFirstName}
              />
            </Col>
            <Col>
              <FormField
                label="Related Person Second Name: "
                value={person.SpouseSecondName}
                name="SpouseSecondName"
                onChange={onChange}
                disabled={disabled || error || !manual}
                error={errors.SpouseSecondName}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormField
                label="Related Person First Last Name: "
                value={person.SpouseFirstLastName}
                name="SpouseFirstLastName"
                onChange={onChange}
                disabled={disabled || error || !manual}
                error={errors.SpouseFirstLastName}
              />
            </Col>
            <Col>
              <FormField
                label="Related Person Second Last Name: "
                value={person.SpouseSecondLastName}
                name="SpouseSecondLastName"
                onChange={onChange}
                disabled={disabled || error || !manual}
                error={errors.SpouseSecondLastName}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              {documentTypes ? (
                <SelectFormField
                  label="Related Person Document Type: "
                  value={person.SpouseDocumentTypeId}
                  name="SpouseDocumentTypeId"
                  onChange={onChange}
                  selectItems={[{ DocumentTypeId: "0", DocumentTypeName: "" }].concat(documentTypes)}
                  getSelectItemId={(document) => document.DocumentTypeId}
                  getSelectItemName={(document) => document.DocumentTypeName}
                  disabled={disabled || error || !manual}
                  error={errors.SpouseDocumentTypeId}
                />
              ) : (
                <CircularProggress sm />
              )}
            </Col>
            <Col>
              <CustomFormInput
                label="Related Person Document Country of Issue: "
                error={errors.SpouseDocumentCountryOfIssueId}
              >
                <Autosuggest
                  value={autosuggests.SpouseDocumentCountryOfIssue}
                  onChange={onChangeDocumentCountry}
                  fecthSuggestions={fetchCountrySuggestion}
                  onSelect={handleChangeDocumentCountry}
                  disabled={disabled || error || !manual}
                />
              </CustomFormInput>
            </Col>
          </Row>
        </div>
      )}
      {!person.PersonIsMinimal && (
        <div>
          <Row>
            <Col>
              <FormField
                label="Related Person Document Expiration Date: "
                error={errors.SpouseDocumentExpirationDate}
                onChange={onChange}
                value={person.SpouseDocumentExpirationDate !== "0000-00-00" ? toDateTime(person.SpouseDocumentExpirationDate) : ""}
                name="SpouseDocumentExpirationDate"
                disabled={disabled || error || !manual}
                type="date"
              />
            </Col>
            <Col>
              <CheckFormField
                label="Related Person Document Without Expiration: "
                error={errors.SpouseDocumentWithoutExpiration}
                onChange={onChange}
                value={person.SpouseDocumentWithoutExpiration}
                initialValue={person.SpouseDocumentWithoutExpiration}
                name="SpouseDocumentWithoutExpiration"
                disabled={disabled || error || !manual}
              />
            </Col>
            <Col>
              <FormField
                label="Related Person Document Number: "
                value={person.SpouseDocumentNumber}
                name="SpouseDocumentNumber"
                onChange={onChange}
                disabled={disabled || error || !manual}
                error={errors.SpouseDocumentNumber}
              />
            </Col>
          </Row>
        </div>
      )}

      {person.PersonType == "Physical" && !person.PersonIsMinimal && (
        <div>
          <Row>
            <Col>
              <FormField
                label="Position Industry: "
                value={person.PhysicalPersonPositionIndustry}
                name="PhysicalPersonPositionIndustry"
                type="textarea"
                onChange={onChange}
                disabled={disabled || error}
                error={errors.PhysicalPersonPositionIndustry}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormField
                label="Working Industry: "
                value={person.PhysicalPersonWorkingIndustry}
                name="PhysicalPersonWorkingIndustry"
                type="textarea"
                onChange={onChange}
                disabled={disabled || error}
                error={errors.PhysicalPersonWorkingIndustry}
              />
            </Col>
            <Col>
              <SelectFormField
                label="Related From: "
                value={person.PersonRelatedFrom}
                name="PersonRelatedFrom"
                selectItems={(onboarding && viewDigitalRelatedFrom < 1) ? Object.keys(RelatedFrom).filter(key => key !== 'Digital') : Object.keys(RelatedFrom)}
                getSelectItemId={(i) => i}
                getSelectItemName={(i) => RelatedFrom[i]}
                error={errors.RelatedFrom}
                onChange={onChange}
                disabled={disabled || error}
              />
            </Col>
            <Col>
              <SelectFormField
                label="Currency Type: "
                value={person.PersonCurrencyType}
                name="PersonCurrencyType"
                selectItems={Object.keys(CurrencyType)}
                getSelectItemId={(i) => i}
                getSelectItemName={(i) => CurrencyType[i]}
                error={errors.CurrencyType}
                onChange={onChange}
                disabled={disabled || error}
              />
            </Col>
          </Row>
        </div>
      )}
      <PhysicalPersonLegalInfo
        person={person}
        onChange={onChange}
        personLinks={personLinks}
        publicPositions={publicPositions}
        documentTypes={documentTypes}
        patrimonies={patrimonies}
        professions={professions}
        activitySectors={activitySectors}
        autosuggests={autosuggests}
        onChangeAutosuggest={onChangeAutosuggest}
        disabled={disabled || error}
        errors={errors}
        companyLinks={companyLinks}
        services={services}
        manual={manual}
      />
      {/* <PhysicalPersonLegalAddress
        legalAddress={legalAddress}
        onChangeAddress={onChangeAddress}
        autosuggests={autosuggests}
        onChangeAutosuggest={onChangeAutosuggest}
        disabled={disabled || error}
        errors={errors}
        services={services}
      /> */}
    </div>
  );
}

PhysicalPersonProfile.propTypes = {
  person: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  personLinks: PropTypes.array,
  publicPositions: PropTypes.array,
  professions: PropTypes.array,
  documentTypes: PropTypes.array,
  companyLinks: PropTypes.array,
  patrimonies: PropTypes.array,
  autosuggests: PropTypes.object.isRequired,
  onChangeAutosuggest: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
};

PhysicalPersonProfile.defaultProps = {
  personLinks: undefined,
  publicPositions: undefined,
  professions: undefined,
  documentTypes: undefined,
  companyLinks: undefined,
  patrimonies: undefined,
};

export default PhysicalPersonProfile;
